/* eslint-disable */
import moment from 'moment'
const ApiService = {
  /******************刷新token****************/
  accessToken: '',
  refreshToken: '',
  refreshTokenDuration: 3000, /* 刷新token的间隔（s） */
  refreshTokenTime: '',
  refreshFlag:false,/*当前是否正在刷新(避免重复调用)*/
  isFirstLogin:false,
  isAdLogin:false,
  mySipInfo:{},//当前登录用户的Sip的信息
 
  //获取缓存中token的数据
  getLocalToken: function(){
    this.accessToken = localStorage.getItem('essAccessToken') ? localStorage.getItem('essAccessToken') : '';
    this.refreshToken = localStorage.getItem('essRefreshToken') ? localStorage.getItem('essRefreshToken') : '';
    this.refreshTokenDuration = localStorage.getItem('essRefreshTokenDuration') ? localStorage.getItem('essRefreshTokenDuration') : 3000;
    this.refreshTokenTime = localStorage.getItem('essRefreshTime') ? localStorage.getItem('essRefreshTime') : '';
  },
  // 清空token
  clearToken: function () {
    this.accessToken = '';
    localStorage.setItem('essAccessToken', '');//token放入缓存
    this.refreshToken = '';
    localStorage.setItem('essRefreshToken','');//刷新token放入缓存
    this.refreshTokenTime = '';
    localStorage.setItem('essRefreshTime', '');//下次刷新token的时间放入缓存
  },
  // 设置刷新token的时间间隔
  setRefreshTokenDuration: function(expiresDuration){
    let duration = 3000;
    if( typeof expiresDuration === 'number' ){
      duration = expiresDuration;
    }
    // token过期前提前30s请求token
    if( duration > 30 ){
      duration = duration - 30;
    }
    this.refreshTokenDuration = duration;
    localStorage.setItem('essRefreshTokenDuration', duration); //将token刷新间隔放入缓存
  },
  // 获取token
  setQueryToken:function (accessToken, refreshToken, expiresDuration) {
    this.setRefreshTokenDuration(expiresDuration);
    let refreshTokenTime = moment().add(this.refreshTokenDuration, "s").format("YYYY-MM-DD HH:mm:ss");
    this.accessToken = accessToken;
    localStorage.setItem('essAccessToken', this.accessToken);//将token的token放入缓存
    this.refreshToken = refreshToken;
    localStorage.setItem('essRefreshToken', this.refreshToken);//将刷新token的token放入缓存
    //获取AccessToken过期需要重新获取的时间
    this.refreshTokenTime = refreshTokenTime;
    localStorage.setItem('essRefreshTime', this.refreshTokenTime);//将下次刷新token的时间放入缓存
  },
  // 注销token
  logoutToken:function (type) {
    let formData = {
      token:this.accessToken.substring(7),
      token_type_hint:type,
      client_id:'ultimo.essential.web.client.v1',
      client_secret:'secret'
    };
    if(localStorage.getItem('isAdLogin') == 'true'){
      formData.token = 'Negotiate'
    }
    formData = new URLSearchParams(formData);
    window.eventBus.$ajax.post('/connect/revocation', formData,
      {
        headers:{ 'Content-Type': 'application/x-www-form-urlencoded'},
        baseURL: window.g.LOGIN_ROOT
      }
    ).then(function (res) {

	  });
  },
  /******************刷新token****************/

  /******************配置项获取***************/
  cacheSearchInfo:{},/*搜索信息保留*/
  /*user名称*/
  staffName:'Staff',
  visitorName:'Visitor',
  vendorName:'Vendor',
  tenantName:'Tenant',
  strangerName:"Stranger",
  accessCodeName:"Access Code",
  userReactiveTime:'',/* user激活时间 */
  // 字段的显示字典, 用于为menu和面包屑过滤可配置的文本. key为显示的需要转换的关键词; value为ApiService对象下的取值的变量名.
  configFieldsMap:{
    Staff:"staffName",
    Visitor:"visitorName",
    Vendor:"vendorName",
    Tenant:"tenantName",
    "Access Code":"accessCodeName"
  },
  //用户动态通知刷新时间
  userNoticeRefresh: 5,
  // 车动态通知刷新
  vehicleNoticeRefresh: 5,
  // alarm map刷新
  alarmMapRefresh: 5,
  // Track and Trace刷新
  faceTrackingRefresh: 5,
  // Static Chart刷新
  staticChartRefresh: 5,
  // PIN
  pinSettingInfo:{enableds:[],mandatorys:[],maxLength:6,defaultValue:'',isSetDefaultValue:true},
  // 是否获取自动AC
  isGetDepartmentAutoAC:true,
  isGetTenantCompanyAutoAC:true,
  // temp access
  tempACSettingInfo:{userTypes: [0,2],maximum: 1},
  cardSettingInfo:{isEnable:false,autoAssignUserTypes:[],mainType:'CSN',requiredUserTypes:[],customCardTypes:[]},/*卡配置*/
  userCardTags:{Staff:[],Visitor:[],Vendor:[],Tenant:[]},/*用户卡tag*/
  /*用户打印配置*/
  staffPrintSetting:{},
  visitorPrintSetting:{},
  vendorPrintSetting:{},
  tenantPrintSetting:{},
  identityInfo:{displayNumber:{Staff:1,Visitor:1,Vendor:1,Tenant:1},displays:{Staff:1,Visitor:1,Vendor:1,Tenant:1}, isEnablePDPA:true, keepFigures:4},// 身份信息配置
  visitorACTime:'00:00-23:59',/*visitor AC默认有效期*/
  customsArray:[[],[],[],[],[]],/*自定义字段*/
  attendanceSettingInfo:{
    types:[],
    startTime:"",
    endTime:"",
    generateTime:""
  },//Attendance Report 的配置
  fastRegistrationSet:{Visitor:true,Vendor:true},/*快速注册类型配置*/
  vehicleSettingInfo:{types:{Car: "Car", Trailer: "Trailer", Truck: "Truck", Motorcycle: "Motorcycle"}},
  defaultMonetaryUnit : '',
  tagNameLength:12,
  architectureText: 'Architecture',
  departmentText: 'Department',
  defaultAreaCode:'',//默认的电话号码区号
  //用户是否需要附件的配置
  attachmentInfo:{
    isEnable: true,
    userTypes: [
      0
    ]
  },
  // 掌纹配置
  palmVeinInfo:{userTypes:[]},
  palmTypes:[],
  // 温度配置
  temperatureInfo: {
    enabled: true
  },
  //dcs配置
  isOpenDCS: false,
  disabledDCSNodeIds: [], // 未开启DCS配置的节点id
  isMandatory:false,
  noEndZone :[],
  noStartZone:[],
  //指纹配置
  fingerprintInfo:{
    isEnableFingerprint: true,
    applicationUserType: [],
    deviceIds: [],
    maxPerPersonFingerprintAmount: 5,
    isRequired:false
  },
  //schedule的配置
  scheduleSettingInfo:{
    timeRuleAmount: 5,
    scheduleUnit: 5, //添加默认值防止无配置报错
  },
  vendorHostRequired:true,// Vendor AC Host必填配置
  visitorHostRequired:true,// Visitor AC Host必填配置
  fileMaximum: 200, // 最大上传文件大小
  userTransform:{Staff:[],Visitor:[],Vendor:[],Tenant:[]},/*User转换配置*/
  generateTime:'9:00',/*z自定义生成报表时间*/
  serverSettingInfo:{
    cpuThreshold1:'',
    cpuThreshold2:'',
    diskThreshold1:'',
    diskThreshold2:'',
    ramThreshold1:'',
    ramThreshold2:'',
  },
  vendorValidityOption:[0,1],/*Vendor有效期选项*/
  userFaceRequired:{},/*user注册是否需要人脸*/
  cardPrefix: {
    1: {
      "prefix": "",
      "country": "",
      "type": "Virtual"
    },
    0: {
      "prefix": "",
      "country": "",
      "type": "Physical"
    }
  },
   /*是否必填*/
  mustWrite:{},
  /*是否开启*/
  judgmentSwitch:{},
  // 是否显示Profile photo字段
  isShowProfilephoto : true,
  hiddenIncidentTypes: [], //隐藏的事件类型
  reserveAutoAC:{ // Department/Tenant Company AC是否保留
    departmentAC:false,
    tenantCompanyAC:false
  },
  userFormField:{Staff:{},Visitor:{},Vendor:{},Tenant:{}},/*User表单字段配置*/
  visitorCompanySet:{companies:[]},
  vendorCompanySet:{companies:[]},
  //esop处理流程获取录音文件的时间限制
  esopFileLimitTime:2,
  //后台任务数据保留时间
  batchTaskRecordKeepTime:0,
  //事件优先级
  priorities: [],
  singleEntry:{userTypes:[],equipments:[]},
  //事件发生时是否自动弹出回放视频
  ejectsInfo:{},
  /*控制系统可添加的设备类型*/
  deviceTypeGroup:[],
  deviceType:{},
  userTableField:{Staff:[],Visitor:[],Vendor:[],Tenant:[]},/*User列表默认字段配置*/
  isQuickEditDcs:false,
  videoLimit:50,
  cardTemplate:{},/* 打印卡默认模板 */
  cardsLength:{},//限制卡号长度
  /*账号相关配置*/
  accountSettingInfo:{},
  qrCodeSetting:{},
  /*dcsEmptyPrompt*/
  dcsEmptyPrompt:false,
  reportSendEmailSizeLimit:20,   /*  发送邮件附件文件大小限制 */
  reportSearchTime:90, /*  报表搜索时间限制 */
  // 人脸去重
  faceDupInfo:{usertTypes:[]},
  // follow up附件最大限制
  attachmentMaxSize: 0,
  /* 自定义事件的配置 */
  customizeIncident:{
    enabled:false,
    functions:[],
  },
  //视频对接方式 （1.通过链接直接缓存资源，2.通过视频服务器请求资源）
  videoDockMode:window.g.videoDockMode,

  // 报表生成限制条数
  reportNormalMax:0,
  reportPhotoMax:0,
  // 获取字段最终显示的文本, 用于为menu和面包屑过滤可配置的文本
  getConfigFieldsText: function(value){
    let _this = this;
    if (!value) {
      return '';
    }
    if( typeof value !== 'string' ){
      value = value.toString();
    }
    let lowerCaseVal = value.toLowerCase();
    if ( lowerCaseVal.indexOf( 'department' ) > -1 && _this.departmentText ){
      value = value.replace(/[d|D]epartment/g, _this.departmentText );
    } 
    else if( lowerCaseVal.indexOf( 'architecture' ) > -1 && _this.architectureText ){
      value = value.replace(/[a|A]rchitecture/g, _this.architectureText );
    } 
    else if( _this.configFieldsMap ){
      for( let key in _this.configFieldsMap ){
        let regExp = new RegExp( key );
        if( _this[ _this.configFieldsMap[ key ] ] ){
          value = value.replace( regExp,  _this[ _this.configFieldsMap[ key ] ] );
        }
      }
    }
    return value;
  },
  // work station配置
  getWorkStationConfig: function(result){
    let _this = this;
    _this.vehicleNoticeRefresh = result['system.setting.node.vehicle.dynamic.notification.refreshinterval'];
    _this.alarmMapRefresh = result['system.setting.node.workstation.alarmmap.refresh.interval'];
    _this.faceTrackingRefresh = result['system.setting.node.workstation.facetracking.refresh.interval'];
    _this.staticChartRefresh = result['system.setting.node.statistic.refresh.time'];
  },
  //获取用户动态通知刷新的时间
  getNotificationDuration: function(result){
    let _this = this;
    _this.userNoticeRefresh = result[''];
  },
  // 获取用户配置
  getUserNames:function (result) {
    let _this = this;
    //用户默认的电话号码区域
    this.defaultAreaCode = result['system.setting.node.user.default.area.code'];
    //用户类型显示名称
    let userNames = result['system.setting.global.user.type.display.name'];
    _this.staffName = userNames.Staff;
    _this.visitorName = userNames.Visitor;
    _this.vendorName = userNames.Vendor;
    _this.tenantName = userNames.Tenant;
    _this.strangerName = userNames.Stranger;

    window.eventBus.common.userType = [];
    window.eventBus.common.userType = [{label:  _this.staffName, value: 0}, {label: _this.visitorName , value: 1}, {label: _this.vendorName, value: 2},{ label: _this.tenantName, value: 3} ];
    window.eventBus.common.reportUserType = [{label:  _this.staffName, value: 0}, {label: _this.visitorName , value: 1}, {label: _this.vendorName, value: 2},{ label: _this.tenantName, value: 3} ];

    //用户打印卡设置
    let userPrintSettings = result['system.setting.node.user.print.card'];
    userPrintSettings.forEach(item =>{
      if(item.userType === 0){
        _this.staffPrintSetting = item;
      } else if(item.userType === 1){
        _this.visitorPrintSetting = item;
      } else if(item.userType === 2){
        _this.vendorPrintSetting = item;
      } else{
        _this.tenantPrintSetting = item;
      }
    });
    //用户类型可使用的卡标签
    let userTypeCardTags = result['system.setting.node.user.type.use.tags'];
    if(JSON.stringify(userTypeCardTags) !== '{}'){
      _this.userCardTags = userTypeCardTags;
    }
    //给Visitor添加AC时，默认选中的有效期
    _this.visitorACTime = result['system.setting.node.user.accesscode.validity'];
  },
  // 获取PIN配置
  getPinConfig:function (result) {
    let _this = this;
    //启用PIN功能的用户类型
    _this.pinSettingInfo.enableds = result['system.setting.global.pin.enabled'] ? result['system.setting.global.pin.user.types'] : [];
    //PIN必填的用户类型
    _this.pinSettingInfo.mandatorys = result['system.setting.global.pin.required.user.types'];
    //PIN长度
    _this.pinSettingInfo.maxLength = result['system.setting.global.pin.length'];
    //是否设置默认PIN
    _this.pinSettingInfo.isSetDefaultValue = result['system.setting.global.pin.enabled.default.value'];
    //默认PIN的值
    _this.pinSettingInfo.defaultValue = result['system.setting.global.pin.default.value'];
    // 是否可见
    _this.pinSettingInfo.isVisible = result['system.setting.global.pin.visible'];
  },
  // 获取自动获取AC配置
  getAutoACConfig:function (result) {
    let _this = this;
    //显示名称
    _this.accessCodeName = result['system.setting.global.accesscode.display.name'];
    if(_this.accessCodeName){
      window.eventBus.common.acType = [
        {label: 'User  ' + _this.accessCodeName, value: 0},
        {label: 'Vehicle  '+_this.accessCodeName, value: 1}
      ];
      window.eventBus.common.tagType[1].label = _this.accessCodeName + ' Tag'
    }
    //部门是否可以添加AC
    _this.isGetDepartmentAutoAC = result['system.setting.global.accesscode.department.auto.use'];
    //租户是否可以添加AC
    _this.isGetTenantCompanyAutoAC = result['system.setting.global.accesscode.tenant.auto.use'];
  },
  // temp access配置
  tempAccessConfig:function (result) {
    let _this = this;
    // 临时AC启用
    _this.tempACSettingInfo.enabled = result['system.setting.global.temp.accesscode.enabled'];
    //使用临时通行规则的用户类型
    _this.tempACSettingInfo.userTypes = result['system.setting.global.temp.accesscode.enabled.usertypes'];
    //每人可添加临时AC数量
    _this.tempACSettingInfo.maximum = result['system.setting.global.temp.accesscode.maximum'];
    //临时AC有效天数
    _this.tempACSettingInfo.effectiveDays = result['system.setting.global.temp.accesscode.effectivedays'];
  },
  // Card配置
  getCardConfig:function (result) {
    let _this = this;
    // 卡号长度限制
    _this.cardsLength = result['system.setting.global.card.length.limit']
    //卡前缀
    if(!(result['system.setting.node.card.card.prefix'] && result['system.setting.node.card.card.prefix'].length)){
      result['system.setting.node.card.card.prefix'] = [
        {
            "prefix": "",
            "country": "",
            "type": "Virtual"
        },
        {
            "prefix": "",
            "country": "",
            "type": "Physical"
        }
      ];
    }
    let cardPrefixObj = {
      1: {
        "prefix": "",
        "country": "",
        "type": "Virtual"
      },
      0: {
        "prefix": "",
        "country": "",
        "type": "Physical"
      }
    };
    result['system.setting.node.card.card.prefix'].forEach((item) => {
      if (item.type === 'Virtual') {
        cardPrefixObj[1] = item;
      } else {
        cardPrefixObj[0] = item;
      }
    })
    _this.cardPrefix = cardPrefixObj;
    //是否启用卡功能
    _this.cardSettingInfo.isEnable = result['system.setting.global.card.enabled'];
    //自动分配卡的用户类型
    _this.cardSettingInfo.autoAssignUserTypes = result['system.setting.node.card.auto.assign.user.types'];
    //主卡号类型
    _this.cardSettingInfo.mainType = result['system.setting.node.card.main.type'];
    //卡号必填的用户类型
    _this.cardSettingInfo.requiredUserTypes = result['system.setting.node.card.required.user.types'];
    //卡类型
    _this.cardSettingInfo.customCardTypes = result['system.setting.global.card.types'];

  },
  // 获取ID配置
  getIdentityConfig:function (result) {
    let _this = this;
    // IC类型
    let icTypeInfo = result['system.setting.global.identity.card.type.display'];
    window.eventBus.common.icType = [{label: icTypeInfo['Others'] || 'Others', value: 0}, {label: icTypeInfo['Id'] || 'ID', value: 1}, {label: icTypeInfo['Passport'] || 'Passport', value: 2}, {label: icTypeInfo['StaffId'] || 'Staff ID', value: 3}, {label: icTypeInfo['VendorId'] || 'Vendor ID', value: 4}, {label: icTypeInfo['TenantId'] || 'Tenant ID', value: 5}, {label: icTypeInfo['FIN'] || 'FIN', value: 6}];
    //证件类型显示数量
    _this.identityInfo.displayNumber = result['system.setting.global.identity.card.show.number'];
    //默认展示证件类型
    _this.identityInfo.displays = result['system.setting.global.identity.card.default.display.type'];
    //是否执行PDPA
    _this.identityInfo.isEnablePDPA = result['system.setting.global.identity.card.pdpa.enabled'];
    //保留位数(用于隐藏证件号)
    _this.identityInfo.keepFigures = result['system.setting.global.identity.card.data.length'];
  },
  // 获取user自定义字段
  getCustomField:function (result) {
    let _this = this;
    _this.customsArray = [[],[],[],[],[]];
    window.eventBus.shareApi.getCustomFields({userTypes:[0,1,2,3]}).done(result =>{
      result.forEach(item =>{
        _this.customsArray[item.userType].push(item);
      })
    });
  },
  // 获取Attendance配置
  getAttendanceSetting:function (result) {
    let _this = this;
    //允许通行的设备
    _this.attendanceSettingInfo.types = result['system.setting.node.attendence.device.types'];
    //生成考勤记录时间
    _this.attendanceSettingInfo.generateTime = result['system.setting.node.attendence.generatetime'];
    //考勤时间段开始时间
    _this.attendanceSettingInfo.startTime = result['system.setting.node.attendence.starttime'];
    //考勤时间段结束时间
    _this.attendanceSettingInfo.endTime = result['system.setting.node.attendence.endtime'];
  },
  //获取车辆相关配置
  getVehicleSetting:function(result){
    let _this = this;
    //默认货币单位
    let type = result['system.setting.node.vehicle.monetary.unit'];
    _this.defaultMonetaryUnit = window.eventBus.common.defaultMonetaryUnits[type];
    //是否启用附件
    _this.vehicleSettingInfo.enableAttachment = result['system.setting.node.vehicle.attachment'];
    //车辆类型和显示名称
    _this.vehicleSettingInfo.types = result['system.setting.global.vehicle.types'];
    //自定义字段
    _this.vehicleSettingInfo.customFields = result['system.setting.node.vehicle.custom.fields'];
    _this.vehicleSettingInfo.isOpencostcenter = result['system.setting.node.vehicle.costcentre.enabled'];
    _this.customsArray[4] = [];
    window.eventBus.$ajax.get('Customize/GetForVehicle').then(function (res) {
      if (res.data.success) {
        _this.customsArray[4] = res.data.data;
      }
    });
  },
  //获取tag相关的配置
  getTagSetting:function(result){
    let _this = this;
    //标签名称最大长度
    _this.tagNameLength = result['system.setting.global.tag.name.maxlength'];
  },
  //获取组织名称配置
  getOrganizationName: function(result){
    let _this = this;
    //组织架构显示名称
    _this.architectureText = result['system.setting.node.organization.display.name'] || 'Architecture';
    //部门显示名称
    _this.departmentText = result['system.setting.node.organization.department.display.name'] || 'Department';

  },
  //获取用户上传附件的设置
  getAttachmentSetting:function(result){
    let _this = this;
    //是否启用附件功能
    _this.attachmentInfo.isEnable = result['system.setting.node.user.attachment.enabled'];
    //开启附件的用户类型
    _this.attachmentInfo.userTypes = result['system.setting.node.user.attachment.usertypes'];
  },
  //获取掌纹设置
  getPalmVeinSetting:function(result){
    let _this = this;
    _this.palmVeinInfo.isEnable=result['system.setting.node.palm.print.configuration.enabled']
    const { Staff, Visitor, Vendor, Tenant } = _this.palmVeinInfo.isEnable
    _this.palmVeinInfo.userTypes[0] = Staff ? 0 : ''
    _this.palmVeinInfo.userTypes[1] = Visitor ? 1 : ''
    _this.palmVeinInfo.userTypes[2] = Vendor ? 2 : ''
    _this.palmVeinInfo.userTypes[3] = Tenant ? 3 : ''
    _this.palmVeinInfo.userTypes = _this.palmVeinInfo.userTypes.filter(item => item !== '');
  },
  //获取温度检测设置
  getTemperatureSetting:function(result){
    let _this = this;
    _this.temperatureInfo.enabled = result['system.setting.node.temperature.enabled'];
    if(!_this.temperatureInfo.enabled){
      let incidentTypes = window.eventBus.common.incidentType;
      delete incidentTypes[3008];
      window.eventBus.common.incidentType = incidentTypes;
    }
  },
  //获取dcs设置
  getDCSSetting:function(result, isMasterNode){
    let _this = this;
    if (isMasterNode) {
      window.eventBus.$ajax.get('DCSZone/QueryAllDCSEnableStatus',{headers: {noLoading: true}}).then(function (res) {
        if(res.data.success){
          let resData = res.data.data || [];
          let disabledDCSNodeIds = [];
          let isOpenDCS = false;
          resData.forEach((item)=>{
            if (item.enabled) {
              isOpenDCS = true;
            } else {
              disabledDCSNodeIds.push(item.id);
            }
          });
          _this.isOpenDCS = isOpenDCS;
          _this.disabledDCSNodeIds = disabledDCSNodeIds;
          _this.isMandatory = false;
        }
      });
    } else {
      _this.isOpenDCS = result['system.setting.node.dcszone.enabled'];
      _this.isMandatory = result['system.setting.node.user.dcszone.required'];
      _this.disabledDCSNodeIds = [];
    }
  },
  //获取指纹配置
  getFingerprintSetting:function(result){
    let _this = this;
    //可使用指纹的用户类型
    _this.fingerprintInfo.applicationUserType = result['system.setting.node.fingerprint.usertypes'];
    //指纹录入设备
    _this.fingerprintInfo.deviceIds = result['system.setting.node.fingerprint.deviceids'];
    //是否启用指纹
    _this.fingerprintInfo.isEnableFingerprint = result['system.setting.node.fingerprint.enabled'];
    //每人最大指纹数量
    _this.fingerprintInfo.maxPerPersonFingerprintAmount = result['system.setting.node.fingerprint.maximum'];
    //是否必填
    _this.fingerprintInfo.isRequired = result['system.setting.node.fingerprint.required'];
  },
  //获取Schedule
  getScheduleSetting:function(result){
    //规则数量限制
    this.scheduleSettingInfo.timeRuleAmount = result['system.setting.global.schedule.time.maximum'];
    //时间单位
    this.scheduleSettingInfo.scheduleUnit = result['system.setting.global.schedule.time.unit'];
  },
  //获取自定义生成报表生成时间
  getGenerateTime:function(result){
    this.generateTime = result['system.setting.global.recurringreport.generatetime'];
  },
  //获取服务器的设置
  getServerSetting:function(result){
    this.serverSettingInfo.cpuThreshold1 = result['system.setting.global.server.management.cpu.yellow.warning.threshold'];
    this.serverSettingInfo.cpuThreshold2 = result['system.setting.global.server.management.cpu.red.warning.threshold'];
    this.serverSettingInfo.diskThreshold1 = result['system.setting.global.server.management.disk.yellow.warning.threshold'];
    this.serverSettingInfo.diskThreshold2 = result['system.setting.global.server.management.disk.red.warning.threshold'];
    this.serverSettingInfo.ramThreshold1 = result['system.setting.global.server.management.ram.yellow.warning.threshold'];
    this.serverSettingInfo.ramThreshold2 = result['system.setting.global.server.management.ram.red.warning.threshold'];
  },
  //获取隐藏事件类型的配置
  getHiddenIncidentTypes: function(result){
    this.hiddenIncidentTypes = result['system.setting.node.incident.not.displayed.types'];
  },
  // 获取User显示字段
  getUserShowFields:function (showField) {
    let _this = this;
    this.userFormField = {Staff:{},Visitor:{},Vendor:{},Tenant:{}};
    if(showField){
      for(let key in showField){
        showField[key].forEach(field =>{
          _this.userFormField[key][field] = true;
        })
      }
    }
  },
  /*获取显示的设备类型*/
  getDeviceTypes:function(result){
    let _this = this;
    let set1 = result['system.setting.global.device.display.type'];
    set1.forEach(el => {
      if(window.eventBus.common.deviceType[el +'']){
        _this.deviceType[el +''] = window.eventBus.common.deviceType[el +'']
      }
    });
    let set2 = new Set(window.eventBus.common.deviceTypeGroup);
    let set3 = Object.values(_this.deviceType);
    let set4 = new Set(set3.map(el => {return el.parent}));
    _this.deviceTypeGroup = Array.from(new Set([...set2].filter(el => set4.has(el.value))));
  },
    /*获取user Qr code 配置*/
    getQrCodeSetting:function(result){
      this.qrCodeSetting = result['system.setting.node.user.qrcode.resend']
    },
  /* 自定义事件的配置 */
  getCustomizeIncident:function(result){
    this.customizeIncident.enabled = result['system.setting.node.incident.customize.enabled'];
    this.customizeIncident.functions = result['system.setting.node.incident.customize.functions'];
  },
  // 虚拟卡与实体卡的处理逻辑
  formatVirtualCard: (cardType, cardNo, isVirtualCard, _this) => {
    let type = Number(isVirtualCard);
    let config = {};
    if(_this.cardPrefix && _this.cardPrefix[type]){
      config = _this.cardPrefix[type]
    }
    return cardType + ' - ' + config.prefix + cardNo;
  },
  //获取所有数据的配置
  getAllConfigSetting:function (nodeId, isMasterNode,callback){
    let _this = this;
    window.eventBus.$ajax.get('SystemSetting/GetGlobalSettings',{headers: {noLoading: true}}).then(function (res) {
      if(res.data.success){
        let result1 = res.data.data;
        _this.getChildrenConfigSetting(nodeId, isMasterNode,callback,result1)
      }
    });
  },
  getChildrenConfigSetting: function(nodeId, isMasterNode,callback,result1){
    let _this = this;
    window.eventBus.$ajax.get('SystemSetting/GetNodeSettings?queryNodeId=' + nodeId,{headers: {noLoading: true}}).then(function (res) {
      if(res.data.success){
        let result = Object.assign(res.data.data,result1);
        _this.vendorHostRequired = result['system.setting.global.user.vendor.host.required'];
        _this.visitorHostRequired = result['system.setting.global.user.visitor.host.required'];
        _this.userTransform = result['system.setting.global.transform.users'];
        _this.fileMaximum = result['system.setting.global.attachment.common.limit.maximum'];
        
        _this.vendorValidityOption = result['system.setting.node.user.vendor.enabled.validity'];
        _this.userFaceRequired = result['system.setting.node.user.face.required'];
        let registerTypes = result['system.setting.node.quick.registration.user.enable'];
        _this.fastRegistrationSet = {
          Visitor: registerTypes.indexOf(1) > -1,
          Vendor: registerTypes.indexOf(2) > -1,
        };
        _this.reserveAutoAC = {
          departmentAC:result['system.setting.node.department.update.user.accesscode.retain'],
          tenantCompanyAC:result['system.setting.node.tenantcompany.update.user.accesscode.retain']
        };
        // Visitor/Vendor Company
        _this.visitorCompanySet = result['system.setting.node.user.visitor.company.setting'];
        _this.vendorCompanySet = result['system.setting.node.user.vendor.company.setting'];
        //esop处理流程获取录音文件的时间限制
        _this.esopFileLimitTime = result['system.setting.global.sip.communication.recording.acquisition.time'];
        //后台任务数据保留时间
        _this.batchTaskRecordKeepTime = result['system.setting.global.backgroudjob.retain.record'];
        //事件优先级
        _this.priorities = result['system.setting.global.incident.priorities'] || [];
        // Single Entry
        _this.singleEntry = {
          enableAccessRule:result['system.setting.global.single.entry.policy.accessrule.enabled'],
          userTypes:result['system.setting.global.single.entry.policy.accessrule.apply.usertypes'],
          equipments:result['system.setting.global.single.entry.policy.use.equipments']
        };
        //事件发生时是否自动弹出回放视频
        _this.ejectsInfo = result['system.setting.global.incident.video'].ejects;
        _this.userTableField = result['system.setting.node.user.list.default.show.field'];
        
        // 快速编辑dcs
        _this.isQuickEditDcs = result['system.setting.node.dcszone.quick.edit.user.zone'];
        //下载报表最大视频数量限制
        _this.videoLimit = result['system.setting.global.report.export.video.limit'];
        // 打印卡模板
        _this.cardTemplate = {
          card: result['system.setting.node.print.template.card.default'],
          sticker: result['system.setting.node.print.template.sticker.default']
        };
        //下载报表发送邮件文件大小限制值(MB)
        _this.reportSendEmailSizeLimit = result['system.setting.global.report.export.send.email.size.limit'];
        //报表搜索时间限制(day)
        _this.reportSearchTime = result['system.setting.global.report.query.time.period'];
         // user AC激活时间
        _this.userReactiveTime = result['system.setting.node.user.reactive.time.period'];
        //账号相关配置
        _this.accountSettingInfo = {
          isAuto: result['system.setting.node.account.password.auto.generate'],
          input: result['system.setting.node.account.mandary.input']
        };
        // 报表生产限制条件
        _this.reportNormalMax=result['system.setting.global.report.export.normalmax'];
        _this.reportPhotoMax=result['system.setting.global.report.export.photomax'];
        // 人脸去重
        _this.faceDupInfo = {
          usertTypes:result['system.setting.global.face.verification.user.type.check'] || [],
        };
        _this.noEndZone = result['system.setting.node.nonselectabledcszone.nonselectable.end.zones']
        _this.noStartZone = result['system.setting.node.nonselectabledcszone.nonselectable.start.zones']
        _this.attachmentMaxSize = result['system.setting.global.attachment.esop.followup.limit.maximum'];
        _this.mustWrite = result['system.setting.node.user.face.profilephoto.required'];
        _this.judgmentSwitch = result['system.setting.global.user.face.profilephoto.required'];
        _this.isShowProfilephoto = _this.judgmentSwitch.Staff || _this.judgmentSwitch.Visitor || _this.judgmentSwitch.Vendor || _this.judgmentSwitch.Tenant;
        // 显示字段
        _this.getUserShowFields(result['system.setting.node.user.show.fields']);
        _this.getWorkStationConfig(result);
        _this.getUserNames(result);
        _this.getCustomField(result1);
        _this.getPinConfig(result);
        _this.getAutoACConfig(result);
        _this.tempAccessConfig(result);
        _this.getCardConfig(result);
        _this.getIdentityConfig(result);
        _this.getAttendanceSetting(result);
        _this.getVehicleSetting(result);
        _this.getTagSetting(result);
        _this.getOrganizationName(result);
        _this.getAttachmentSetting(result);
        _this.getTemperatureSetting(result);
        _this.getDCSSetting(result, isMasterNode);
        _this.getFingerprintSetting(result);
        _this.getScheduleSetting(result);
        _this.getGenerateTime(result);
        _this.getServerSetting(result);
        _this.getHiddenIncidentTypes(result);
        _this.getCustomizeIncident(result);
        _this.getDeviceTypes(result);
        _this.getQrCodeSetting(result);
        _this.getPalmVeinSetting(result);
        if(callback){
          callback();
        }
      }
    });
  },
  
  // 获取所有节点的想要的配置
  mainCardType:{},
  getMainCardType:function(nodeIds,keys) {
    let _this = this;
    let params = {
      queryNodeIds: nodeIds,
      keys: keys
    };
    window.eventBus.$ajax.post('SystemSetting/QueryMultiBuildingSettings', params, {headers: {noLoading: true}}).then(function (res) {
      if(res.data.success){
        let obj = {};
        res.data.data.forEach(el => {
          obj[el.buildingId] = el.values['system.setting.node.card.main.type'];
        });
        _this.mainCardType = obj;
        console.log(_this.mainCardType);
      }
    });
  },
  /******************配置项获取***************/
};
export default ApiService;



//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/js/ApiService.js
// module id = 4Kq2
// module chunks = 15